import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-linked-record-status',
  standalone: false,
  templateUrl: './linked-record-status.html',
  styleUrl: './linked-record-status.scss',
})
export class LinkedRecordStatus {
  @Input() label = '';
  @Input() link: string | any[] | null = null;
  @Input() status = 'None';
  @Output() linkActivated = new EventEmitter<void>();

  get accessibleTitle(): string {
    const label = this.label.trim() || 'No linked record';
    const status = this.status.trim() || 'None';
    return `${label} — ${status}`;
  }

  get displayStatus(): string {
    const value = this.status.trim().replace(/[_-]+/g, ' ');
    if (!value) {
      return 'None';
    }
    return value.replace(/\b\w/g, (character) => character.toUpperCase());
  }

  get badgeClass(): string {
    const status = this.status.trim().toLowerCase().replaceAll('_', ' ');

    if (
      [
        'done',
        'posted',
        'paid',
        'validated',
        'delivered',
        'invoiced',
        'billed',
        'complete',
        'completed',
        'resolved',
        'closed',
        'active',
      ].includes(status)
    ) {
      return 'bg-green-lt text-green';
    }

    if (
      [
        'ready',
        'open',
        'sent',
        'processing',
        'in progress',
      ].includes(status)
    ) {
      return 'bg-blue-lt text-blue';
    }

    if (
      [
        'partial',
        'waiting',
        'to bill',
        'to invoice',
        'draft bill',
        'pending',
      ].includes(status)
    ) {
      return 'bg-yellow-lt text-yellow';
    }

    if (
      [
        'cancelled',
        'canceled',
        'failed',
        'blocked',
        'overdue',
        'breached',
        'rejected',
      ].includes(status)
    ) {
      return 'bg-red-lt text-red';
    }

    return 'bg-secondary-lt text-secondary';
  }

}
